const graphicEl = document.querySelector('.graphic > figure');
        const rangeEl = document.querySelector('.graphic > input[type="range"]');

        function refreshMax() {
            rangeEl.max = graphicEl.scrollWidth - graphicEl.clientWidth;
        }

        graphicEl.addEventListener('scroll', () => {
            refreshMax();
            rangeEl.value = graphicEl.scrollLeft;
        });

        rangeEl.addEventListener('input', () => {
            refreshMax();
            graphicEl.scrollLeft = rangeEl.value;
        });